import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Configuration } from 'src/app/enum/Configuration';
import { ApplicationDataService } from 'src/app/services/application-data.service';
import { DataService } from 'src/app/services/data.service';
import { LookupDataServiceService } from 'src/app/services/lookup-data-service.service';
import { NotificationService } from 'src/app/services/notification-service';
import { ServiceChangeRequestService } from 'src/app/services/service-change-request.service';
import { UserSessionService } from 'src/app/services/usersession.service';

@Component({
  selector: 'app-manage-cancellation-popup',
  templateUrl: './manage-cancellation-popup.component.html',
  styleUrls: ['./manage-cancellation-popup.component.scss']
})
export class ManageCancellationPopupComponent implements OnInit {
  hcUserList: any[] = [];
  filteredHCUserList: any[] = [];
  displayType: any;
  head: any;
  data: any;
  ismanual: any;
  form: FormGroup;
  fsan: any;
  serviceproviderType = Configuration
  reasonList: any;
  vumatelNetworkIdentifier: any
  FrongfootreasonList: any;
  approveform: FormGroup;
  vapproveform: FormGroup;
  date = new Date();
  nextDate = new Date(this.date);
  formattedDate: any;
  isPromotionChecked: boolean = false;
  isNotRecurringDate = true;
  retentionPromoDetails: any;
  serviceChangeRequestId: number;
  isRetentionPromoApplicable: boolean = false;
  allowedEmails: any;
  sessionDataString: any;
  isEmailAllowed: boolean = false;

  complexlist: any;
  filteredList: any;
  isvumatel = false;
  isBalwin = false;
  isfrogfoot = false;
  isAgree: any;
  filteredList1: any;
  isamend: any;
  IsshoppingOrders: any;
  @ViewChild('effectivedate') startDatePicker: MatDatepicker<Date>;
  filteredList2: any
  reasonType: any
  filteredRejectReasonList: any[] = [];
  rejectReasonList: any;
  retentionPromoList: any;
  isRetentionPromoCodeSelected: boolean = false;
  matchedRetentionPromo: any;

  constructor(
    public dialogRef: MatDialogRef<ManageCancellationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public value: any,
    private formBuilder: FormBuilder,
    private applicationDataService: ApplicationDataService,
    private LookupDataService: LookupDataServiceService,
    private toast: NotificationService,
    private serviceChangeRequestService: ServiceChangeRequestService,
    private dataService: DataService,
    private sessionService: UserSessionService,

  ) {
    this.nextDate.setDate(this.date.getDate() + 1);
    this.formattedDate = this.formatDate(this.nextDate);
    this.sessionDataString = JSON.parse(
      localStorage.getItem(this.sessionService.localStorageSessionKey)
    );
    console.log(this.sessionDataString);

  }

  ngOnInit(): void {
    this.displayType = this.value.title
    this.ismanual = this.value.ismanual
    this.head = this.value.head;

    this.form = this.formBuilder.group({
      comment1: ['', Validators.required],
      comment2: [],
      cancellationReasonByAdmin: [],
      commentCreatedTs: [],
      commentModifiedTs: [],


    })
    if (this.value.data) {
      this.data = this.value.data;
      this.serviceChangeRequestId = this.data.serviceChangeRequestId;
      // console.log(this.data)


      this.form.controls['comment1'].setValue(this.data.comment1);
      this.form.controls['comment2'].setValue(this.data.comment2);
      this.form.controls['cancellationReasonByAdmin'].setValue(this.data.adminCancellationReason);
      this.form.controls['commentCreatedTs'].setValue(this.data.commentCreatedTs);
      this.form.controls['commentModifiedTs'].setValue(this.data.commentModifiedTs);
    }
    console.log('data', this.data)
    if (this.displayType == 'acknowledgment') {
      this.applicationDataService.getcancelreason().subscribe((result) => {
        this.reasonType = result
        this.filteredList2 = [...this.reasonType]
      })
    }
    if (this.displayType != 'acknowledgment') {
      this.data = this.value.data;

      this.IsshoppingOrders = this.value.IsshoppingOrders;
      this.approveform = this.formBuilder.group({
        effectivedate: [this.data.requestedCancellationDate,],
        fsan: [{ value: null, disabled: true }]
      })

      this.vapproveform = this.formBuilder.group({
        effectivedate: [this.data.requestedCancellationDate],
        vumatelNetworkIdentifier: [],
        balwinComplexType: [],
        complexUnitNo: [],
        fsan: [{ value: null, disabled: true }],
        reason: [],
        retentionAgent: ['', [Validators.required]],
        retentionPromoCode: [],
        discountedPrice: [],
        originalPrice: [],
        savingsAmount: [],
        Frongfootreason: [{ key: null, value: null }],
        cancelreason: [{ key: null, value: null }],
        radioResult: [null],


      })
      if (this.data.approveCancellationDate) {
        this.vapproveform.controls['effectivedate'].setValue(this.data.approveCancellationDate);

      }
      this.getdata();
      this.loadRetentionAgents();
      this.loadRejectReasons();
      this.CheckRetentionPromoIsApplicable(this.data.applicationId);
      this.getUserEmailsForAddingRetentionPromo();
      this.isTwentyThird();

    }


  }
  loadRetentionAgents() {
    this.dataService.getRecord('/api/lookup/getHCUserList')
      .subscribe((res: any) => {
        this.hcUserList = res
        this.filteredHCUserList = [...this.hcUserList];
      });
  }
  loadRejectReasons() {
    this.LookupDataService.getRejectReasonsList().subscribe(
      (res: any) => {
        this.rejectReasonList = res
        this.filteredRejectReasonList = [...this.rejectReasonList]
      }
    )
  }

  Close() {
    this.isAgree = false
    let data = { isAgree: this.isAgree }
    console.log('popupdata', data)

    this.dialogRef.close(data)

  }
  onsubmit() {
    if (this.form.valid) {
      if (this.data.serviceproviderId != 1 && this.data.serviceproviderId != 6 && this.data.serviceproviderId != 14 && !this.form.value.cancellationReasonByAdmin) {
        this.form.controls['cancellationReasonByAdmin'].setErrors({ required: true })
        return
      }
      let data: any = this.form.value;
      this.isAgree = "yes";
      data = { data: data, isAgree: this.isAgree }
      console.log('popupdata', data)

      this.dialogRef.close(data)
    }
  }

  formatDate(date: Date | null): string {
    if (!date) return '';
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  getdata() {
    console.log('display', this.displayType)

    if (!this.ismanual && this.displayType != "reject") {
      this.applicationDataService.getServiceActivationNumber(this.data.applicationId).subscribe((result) => {


        console.log('getServiceActivationNumber', this.approveform.value)
        if (this.data.serviceProviderId == this.serviceproviderType.Vumatel) {
          this.serviceChangeRequestService.getVumetalTerminationReasons().subscribe((result) => {
            this.reasonList = result;
            this.filteredList1 = [...this.reasonList];
          })
          this.isamend = this.value.isamend;

          this.isvumatel = true;
          this.vapproveform.controls['vumatelNetworkIdentifier'].setValue(result);


          this.vumatelNetworkIdentifier = result
        }
        else if (this.data.serviceProviderId == this.serviceproviderType.Frogfoot) {
          this.isfrogfoot = true;
          this.serviceChangeRequestService.getFrogfootTerminationReasons().subscribe((result) => {
            this.reasonList = result;
            this.filteredList1 = [...this.reasonList];
          })
          this.isamend = this.value.isamend;

          this.vapproveform.controls['fsan'].setValue(result);


          this.vumatelNetworkIdentifier = result
        }
        else {
          this.vapproveform.controls['fsan'].setValue(result);

        }


      })
      if (this.data.serviceProviderId == this.serviceproviderType.Balwin)
        this.isBalwin = true;
      this.LookupDataService.getBalwinComplexType().subscribe((result) => {
        this.complexlist = result;
        this.filteredList = [...this.complexlist];
        this.LookupDataService.getComplexUnitNumber(this.data.serviceChangeRequestId).subscribe((result) => {
          if (result)
            this.vapproveform.controls['ComplexUnitNo'].setValue(result);

        })
      })

    }

  }

  approveonsubmit() {
    let values = this.vapproveform.getRawValue();
    console.log(values.effectivedate)
    console.log(this.nextDate)

    if (values.effectivedate)
      console.log('date')

    if (values.effectivedate < this.formattedDate && this.displayType != "reject") {
      this.vapproveform.controls['effectivedate'].setErrors({ required: true });
      console.log('problem date')
      this.toast.showError("The effectivedate date is lesser than today!");
      return;
    }
    if (this.displayType != "reject") {
      if (this.vapproveform.valid) {
        if (this.ismanual) {
          this.data.isAgree = "Yes";
          this.dialogRef.close();
        }
        if (this.isvumatel) {
          if (!values.cancelreason.key) {
            this.vapproveform.controls['cancelreason'].setErrors({ required: true });
            return;
          }
          if (!values.vumatelNetworkIdentifier) {
            this.vapproveform.controls['vumatelNetworkIdentifier'].setErrors({ required: true });
            return;
          }
        }
        if (this.isfrogfoot) {
          if (!values.Frongfootreason.key) {
            this.vapproveform.controls['Frongfootreason'].setErrors({ required: true });
            return;
          }
        }
        if (this.isBalwin)
          if (!values.balwinComplexType && !values.complexUnitNo) {
            this.vapproveform.controls['complexUnitNo'].setErrors({ required: true });
            this.vapproveform.controls['balwinComplexType'].setErrors({ required: true });
            return;
          }
          else if (!values.balwinComplexType) {
            this.vapproveform.controls['balwinComplexType'].setErrors({ required: true });
            return;
          }
          else if (!values.complexUnitNo) {
            this.vapproveform.controls['complexUnitNo'].setErrors({ required: true });
            return;
          }

      }
    }
    else if (this.displayType == 'reject') {
      console.log(values)

      if (!values.reason) {
        this.vapproveform.controls['reason'].setErrors({ required: true });
        return;
      }
      if (!values.retentionAgent) {
        this.vapproveform.controls['retentionAgent'].setErrors({ required: true });
        return;
      }
      if (this.isPromotionChecked && (values.retentionPromoCode === null || values.retentionPromoCode === undefined || values.retentionPromoCode === '')) {
        this.vapproveform.controls['retentionPromoCode'].setErrors({ required: true });
        return;
      }
    }
    const selectedReason = values.reason
    // if (values.retentionAgent == null || values.retentionAgent == '') {
    //   values.retentionAgent = null;
    //   values.retentionAgentName = null;
    // }
    // else {
    const selectedUser = this.hcUserList.find(
      u => u.userId == values.retentionAgent
    );

    values.retentionAgentName = selectedUser
      ? `${selectedUser.firstName} ${selectedUser.lastName}`
      : null;
    values.reason = selectedReason;
    values.retentionPromoCode = values?.retentionPromoCode
    values.hasRetentionPromo = this.isRetentionPromoApplicable
    // }
    this.isAgree = "yes";

    let data: any = { isAgree: this.isAgree, data: values }
    console.log(data)
    this.dialogRef.close(data)

  }

  onRetentionPromoCodeSelected(event?: MatSelectChange) {
    if (event != null) {
      this.isRetentionPromoCodeSelected = event.value;
      if (this.isRetentionPromoCodeSelected) {

        this.matchedRetentionPromo = this.retentionPromoDetails.find(
          item => item.retentionPromoCode === event.value
        ) ?? null;
      }
    }
  }

  promotionChange(event?: MatCheckboxChange) {
    if (event != null) {
      this.isPromotionChecked = event.checked;
      if (this.isPromotionChecked) {
        this.getRetentionPromotionPricing(this.data.applicationId);
      }
      else {
        // Clear value and remove validation error when unchecked
        this.vapproveform.controls['retentionPromoCode'].setValue(null);
        this.vapproveform.controls['retentionPromoCode'].setErrors(null);
        this.isRetentionPromoCodeSelected = false;
        this.matchedRetentionPromo = null;
      }
    }
  }

  getRetentionPromotionPricing(applicationId) {
    this.serviceChangeRequestService.getRetentionPromotionPricing(applicationId).subscribe(
      (res: any) => {
        if (res) {
          this.retentionPromoDetails = res
          // this.vapproveform.patchValue({
          //   retentionPromoCode: res.map(item => item.retentionPromoCode),
          // });
          debugger
          this.retentionPromoList = res.map(item => item.retentionPromoCode);
        }
      }
    )
  }

  CheckRetentionPromoIsApplicable(appId) {
    this.serviceChangeRequestService.CheckRetentionPromoIsApplicable(appId).subscribe(
      (res: any) => {
        if (res)
          this.isRetentionPromoApplicable = res
        // else
        //   this.toast.showInfo("Retention promotion can't apply to this record")
      }
    )
  }

  getUserEmailsForAddingRetentionPromo() {
    if (this.sessionDataString.roleId != 17) {
      this.serviceChangeRequestService.getUserEmailsForAddingRetentionPromo().subscribe(
        (res: any) => {
          if (res) {
            this.allowedEmails = res
            this.isEmailAllowed = this.isEmailAllowedMethod();
          }
        })
    }
    else
      this.isEmailAllowed = true;
  }
  isEmailAllowedMethod(): boolean {
    const userEmail = this.sessionDataString?.emailid?.toLowerCase() ?? '';
    console.log(userEmail)
    return (this.allowedEmails.map(e => e.toLowerCase()).includes(userEmail));
  }

  isTwentyThird() {
    const today = new Date();
    console.log("today date", today.getDate())
    if (today.getDate() === 23) {
      this.isNotRecurringDate = false;
    }
    else {
      this.isNotRecurringDate = true;
    }
  }

}






